module.exports = __webpack_public_path__ + "img/account_mb_03.5c822dc9.jpg";